import Swal from "sweetalert2"
import { CREATE_POST_STREAM, CREATE_STREAM } from "../actions/types"
import inMemoryJwt from "../auth/inMemoryJwt"
import { urlServer } from "../config/GlobalConstant"

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000
})
export const createStream = () => async dispatch => {
    await fetch(`${urlServer}stream/create-channel`, {
        withCredentials: true,
        credentials: 'include',
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        headers: {
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
        },    
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type:CREATE_STREAM,
                payload:respJson.data
            })
        })
        .catch(error => {
            console.log()
        })
}
export const createPostStream = (post, history, isProfessionalUser, isShared) => async dispatch => {
    // const accessToken= inMemoryJWT.getToken()
    
        await fetch(`${urlServer}posts/create`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
//mode: 'cors', // no-cors, *cors, same-origin
           // withCredentials: true,
            //credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJwt.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            body:JSON.stringify( post) // body data type must match "Content-Type" header
        })
            .then(response => response.json())
            .then(respJson => {
                console.log()
                if (respJson.success === true) {
                    dispatch({type:CREATE_POST_STREAM,payload:respJson.data})
                    Toast.fire({
                        icon: 'success',
                        title: 'Publicado con éxito'
                    })
                    
                }
            })
            .catch(error => {
                console.log()
            })
}